export default __webpack_public_path__ + "static/media/chille.3f2d7b26.jpg";